import { Box, Button, Dialog, DialogContent, IconButton, Link, Tooltip, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DeleteForever, ErrorOutline } from "@mui/icons-material";
import { Modes } from "./types";
import { KeepInMindInfoIcon } from "./KeepInMindInfoIcon";

export interface UserDocumentDialogComponentProps {
  isOpen: boolean
  onCancel: () => void
  cloudUrl?: string,
  setMode?: (mode: Modes) => void,
}

export function getBestCloudDocHostName(cloudUrl: string): string {
  const matchers: { [key: string]: RegExp } = {
    "Google": /google\.com/gi,
  }

  const keyIndex = Object.keys(matchers).findIndex(k => {
    if (matchers[k].test(cloudUrl)) {
      return true
    }

    return false
  })

  if (keyIndex !== -1) {
    return Object.keys(matchers)[keyIndex]
  }

  return "Cloud"
}

export function UserDocumentDialogEmbedComponent({
  isOpen,
  onCancel,
  cloudUrl,
  setMode
}: UserDocumentDialogComponentProps): JSX.Element {

  return (
    <Dialog
      fullScreen={true}
      style={{ margin: "1rem", padding: 0 }}
      open={isOpen}
      onClose={onCancel}
    >
      <DialogContent sx={{ paddingLeft: "0.5rem", paddingRight: "0.5rem", paddingTop: 0, paddingBottom: 0 }}>
        <div style={{ display: "flex", justifyContent: "end", alignItems: "center", minHeight: "3rem" }}>
          {cloudUrl && <a
            href={cloudUrl}
            target="_blank"
            style={{ marginRight: "1rem" }}
            onClick={() => onCancel?.()}>
            View in {getBestCloudDocHostName(cloudUrl)}
          </a>}
          <KeepInMindInfoIcon />
          <IconButton aria-label="delete"
            title="Remove from Atticus"
            style={{ marginRight: "1rem", color: "#444" }}
            onClick={() => setMode?.(Modes.delete)}
          >
            <DeleteForever />
          </IconButton>
          {onCancel ? (
            <IconButton
              aria-label="close"
              sx={{
                padding: 0,
              }}
              onClick={onCancel}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </div>
        <div style={{ height: "calc(100% - 7rem)", border: "1px solid #eee" }}>
          <iframe
            width="100%"
            height="100%"
            frameBorder="0"
            scrolling="no"
            src={cloudUrl}
            style={{ overflow: "auto" }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "4rem" }}>
          <Button variant="outlined" onClick={() => onCancel?.()}>Back to my files</Button>
          {cloudUrl && <Button href={cloudUrl} variant="outlined" target="_blank">View in {getBestCloudDocHostName(cloudUrl)}</Button>}
        </div>
      </DialogContent>
    </Dialog>
  )
}